import React from 'react';

import {useFormik } from 'formik';
import Swal from 'sweetalert2';
import * as Yup from 'yup';
export default function Forms(props) {
	//const [subEmail, setSubEmail] = useState('')
	const formik = useFormik({
		initialValues: {

			name: '',
			email: '',
			phone: '',
			message: '',
			formsource: ''
		},
		validationSchema: Yup.object({
			name: Yup.string()
				.max(50, 'username must be less than or equal to 10 char')
				.required("Please Enter Name"),

			phone: Yup.string()
				.required("Please Enter Mobile No."),

			email: Yup.string()
				.required("Please Enter Email Id ")
				.email("Please provide a valid email id"),

			message: Yup.string()
				.required("Enter Your Massage"),

		}),
		onSubmit: (value, onSubmitProps) => {
			console.log('all values : ',value);
			console.log('onSubmitProps : ',onSubmitProps);
			let formData = new FormData();
			formData.append('name', value.name);
			formData.append('email', value.email);
			formData.append('phone', value.phone);
			formData.append('message', value.message);
            formData.append('formsource', value.formsource);

			let result = fetch('https://unlockdestinations.in/sendMail.php', {
                 //let result = fetch('https://rightjobsavenue.com/mailer.php', {
				method: 'POST',
				body: formData,
				// headers: {
				//  'Content-type': 'application/json; charset=UTF-8',
				//   'Content-type': 'multipart/form-data; ',
				//  },
			})
				.then((response) => response.json())
				.then((data) => {
					if (data === '1') {
						Swal.fire({
							//position: 'top-end',
							icon: 'success',
							title: data.msg,
							showConfirmButton: false,
							timer: 1500
						})
						onSubmitProps.setSubmitting(false);
						onSubmitProps.resetForm();
						('textarea').text("");


					} else {
						Swal.fire({
							//position: 'top-end',
							icon: 'success',
							title: data.data,
							showConfirmButton: false,
							timer: 1500
						})

						onSubmitProps.setSubmitting(false);
						onSubmitProps.resetForm();
						('textarea').text("");
					}

					
				})
				.catch((err) => {
					console.log(err.message);
				});

		}
	})



  return (
    <>
      <form  onSubmit={formik.handleSubmit}>
                            <div className="form-group">
                                <input type="text" className="form-control" name='name' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.name}  placeholder="Name" id="name" />
                                	{formik.touched.name && formik.errors.name && <div className="form-alert"><i className='icon icon-alert'></i>{formik.errors.name} </div>}

													<span className="glyphicon form-control-feedback" aria-hidden="true"></span>
													<div className="help-block with-errors"></div> 
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control" name='email' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.email}  placeholder="Email" id="email"  /> 
                                {formik.touched.email && formik.errors.email && <div className="form-alert"><i className='icon icon-alert'></i>{formik.errors.email} </div>}

													<span className="glyphicon form-control-feedback" aria-hidden="true"></span>
													<div className="help-block with-errors"></div>

                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control"  name='phone' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.phone} placeholder="Phone"  id="phone" /> 
                                {formik.touched.phone && formik.errors.phone && <div className="form-alert"><i className='icon icon-alert'></i>{formik.errors.phone} </div>}
                            </div>
                            <div className="form-group">
                                <textarea  onChange={formik.handleChange} onBlur={formik.handleBlur}  className="form-control" id="message" name="message" placeholder="Message" value={formik.values.message} />
                                {formik.touched.message && formik.errors.message && <div className="form-alert"><i className='icon icon-alert'></i>{formik.errors.message} </div>}
                            </div>
						
                            <input type="text"  style={{ display:"none"}}  name='formsource' onChange={formik.handleChange} onBlur={formik.handleBlur} value={props.formsource} placeholder="formsource"  id="formsource" /> 
                               
                            <div className="form-group">
                                <button type='submit' className="btn submitBtn">{props.submitBtnName}</button> 
                            </div>
                        </form>
    </>
  )
}
